var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappyOutsideFoodNot = function SvgHappyOutsideFoodNot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF5F7",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A5C",
    d: "M14.5 6.82a.775.775 0 0 0-.775-.73h-1v-.5A2.612 2.612 0 1 0 7.5 5.6c0 2.045 0 1.955.07 2.085a.375.375 0 0 1-.68-.215V6.09h-.6a.78.78 0 0 0-.79.73c-.5 6.96-.465 6.575-.465 6.94A1.24 1.24 0 0 0 6.29 15h7.42a1.24 1.24 0 0 0 1.24-1.24c0-.355.02.055-.45-6.94m-3.14-.73H8.265v-.5a1.855 1.855 0 0 1 3.705 0c0 2.05 0 1.955.07 2.085a.375.375 0 0 1-.68-.215zm-.525 2.605a.25.25 0 0 1 .33-.115 3.29 3.29 0 0 1 1.5 2.975.25.25 0 0 1-.25.25H11.31v1.39a.25.25 0 0 1-.25.25.255.255 0 0 1-.25-.25c0-4.65-.01-4.425.025-4.5M7.55 8.75a.25.25 0 0 1 .5 0v1.565c0 .15.175.315.45.38V8.75a.25.25 0 0 1 .5 0v1.945c.275-.065.455-.23.455-.38V8.75a.25.25 0 0 1 .5 0v1.565a1 1 0 0 1-.955.89v2a.25.25 0 0 1-.25.25.255.255 0 0 1-.25-.25v-2a1 1 0 0 1-.95-.89z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#happyOutsideFoodNot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FF3A5C",
    strokeLinecap: "round",
    d: "M16 4.707 4.707 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "happyOutsideFoodNot_svg__a",
    width: 12.293,
    height: 13.293,
    x: 4.207,
    y: 3.207,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.960784 0 0 0 0 0.968627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3004_65"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3004_65",
    result: "shape"
  })))));
};
export default SvgHappyOutsideFoodNot;